import { formatNumber } from '../../../../components/Percent';
import styles from './_totals.module.css';

interface ITotalProps {
  data: any,
  showAverage: boolean
}

const Totals = (props: ITotalProps) => (
  <div className={styles.totalsContainer}>
    { props.showAverage && 
      <div>
          <span>Resultado promedio: </span> {formatNumber(props.data.average, 2)}
      </div>
    }
      <div>
          <span>Respuestas en rango: </span> {formatNumber(props.data.total_range, 0)}
      </div>
      <div>
          <span>Respuestas totales: </span> {formatNumber(props.data.total, 0)}
      </div>
  </div>
);

export default Totals;